import React from 'react';
import {useField} from 'formik';

import {COURSE_TYPE_OPTIONS} from 'shared/utils';

import Label from 'shared/components/label';
import FormikDropdown from 'src/components/formik-dropdown';
import {CourseForm} from './course-form-wrapper';
import {ButtonSizes} from 'shared/constants';

interface Props {
  className?: string;
  size?: ButtonSizes;
  prefix?: string;
}

const CourseTypeDropdown = ({className, size = 'medium', prefix = ''}: Props) => {
  const [courseTypeField, courseTypeMeta] = useField<CourseForm['courseType']>(
    `${prefix}courseType`
  );
  const [institutionField, institutionMeta, institutionHelpers] = useField<
    CourseForm['institution']
  >(`${prefix}institution`);

  return (
    <Label className={className} required>
      Course Type
      <FormikDropdown
        name={`${prefix}courseType`}
        options={COURSE_TYPE_OPTIONS}
        required
        onChange={({target: {value}}) => {
          if (
            (courseTypeMeta.initialValue !== 'Dual Enrollment' && value === 'Dual Enrollment') ||
            (courseTypeMeta.initialValue === 'Dual Enrollment' && value !== 'Dual Enrollment')
          ) {
            institutionHelpers.setValue({
              ...institutionField.value,
              parentId: '',
              name: '',
            });
          } else if (
            (courseTypeMeta.initialValue !== 'Dual Enrollment' &&
              value !== 'Dual Enrollment' &&
              courseTypeField.value === 'Dual Enrollment') ||
            (courseTypeMeta.initialValue === 'Dual Enrollment' &&
              value === 'Dual Enrollment' &&
              courseTypeField.value !== 'Dual Enrollment')
          ) {
            if (institutionMeta.initialValue) {
              institutionHelpers.setValue(institutionMeta.initialValue);
            } else {
              institutionHelpers.setValue({
                ...institutionField.value,
                parentId: '',
                name: '',
              });
            }
          }
        }}
        size={size}
        testid="bulk-entry-course-type"
      />
    </Label>
  );
};

export default CourseTypeDropdown;
